export const routerRestApi = [
  {
    path: '/rest-api',
    meta: { title: 'Rest Api' },
    component: () => import('@/views/rest-api/index.vue'),
  },
  {
    path: '/rest-api/distributor',
    meta: { title: 'Rest Api Distributor' },
    component: () => import('@/views/rest-api/distributor/index.vue'),
  },
  {
    path: '/rest-api/distributor-curah',
    meta: { title: 'Rest Api Distributor Curah' },
    component: () => import('@/views/rest-api/distributor-curah/index.vue'),
  },
]
